const getSessionData = (params: string) => {
  return sessionStorage.getItem(params)
}

export { getSessionData }
